import React from 'react';
import FranquiciasForm from './CatastrosForm';

const NuevoCatastros = () => {
    return <FranquiciasForm mode="ADD" />;
};

export default NuevoCatastros;
